export const GET_ROUTE_INFO_TOOL_NAME = "get_route_info";

export const DEFAULT_LIMIT = 5;
export const MAX_LIMIT = 10;
